(function documentContainerDocumentsControllerDefinition() {
    'use strict';

    angular.module('EmployeeFile')
        .controller('EmployeeFileAddController', [
            '$scope', 'config', '$state', 'errorsExtend', 'documentContainerService', 'authExtend', 'containerTypeService', 'adminContainerTypeService', 'organizationalUnitConfigService', 'certificateService', 'profileCertificateService', '$filter',
            function employeeFileAdd($scope, config, $state, errors, documentContainerService, authExtend, containerTypeService, adminContainerTypeService, organizationalUnitConfigService, certificateService, profileCertificateService, $filter) {

                $scope.cancel = function () {
                    $state.go('employee-file-find');
                };

                $scope.title = 'EmployeeFileAdd';

                $scope.load = function () {
                    $scope.container = {
                        name: '',
                        code: '',
                        containerTypeId: config.custom('employeeFileTypeId'),
                        containerTypeName: '',
                        parentDocumentContainerId: '',
                        metadatas: [],
                        documents: [],
                        organizationalUnitId: authExtend.getOrganizationId(),
                        organizationalUnitName: authExtend.getOrganizationName()
                    };

                    $scope.optionsContainerTypes = [];
                    $scope.optionsDocumentCategories = [];
                    $scope.optionsDocumentTypes = [];
                    $scope.organizationalUnit = {};
                    $scope.emptyOu = false;

                    $scope.loadContainerType();
                };

                $scope.change = function ($value) {
                    if ($value && $value.metadataSystemName === '_userId' && $value.metadataValue) {
                        var filters = {
                            PartialQuery: true,
                            ContainerTypes: []
                        };

                        filters.ContainerTypes.push($scope.container);
                        filters.ContainerTypes[0].SystemName = '_leg';
                        filters.ContainerTypes[0].DocumentTypeId = $scope.container.containerTypeId;
                        filters.ContainerTypes[0].metadatas.forEach(function (item) {
                            if (item.metadataSystemName === '_userId') {
                                item.metadataValueFrom = $value.metadataValue;
                            } else if (item.metadataSystemName === '_estado') {
                                item.metadataValueFrom = 'Activo';
                            }
                        });

                        documentContainerService.advancedGet(filters).then(function (result) {
                            if (result.values && result.values.length > 0) {
                                errors.showWarning("EmployeeFileExists", { userName: $value.userName });

                                $scope.container.metadatas.forEach(function (item) {
                                    item.metadataValue = undefined;
                                });
                            }
                        }, function (error) {
                            errors.showError(error);
                        });
                    }
                };

                $scope.loadContainerType = function () {
                    adminContainerTypeService.getMetadataMappings(authExtend.getOrganizationRoot()).then(function (result) {
                        var customContainerType = undefined;

                        for (var i = 0; i < result.length; i++) {
                            if (result[i].sourceMetadataMapping.length > 0 && result[i].targetMetadataMapping.length > 0) {
                                customContainerType = result[i];
                            }
                        }

                        if (customContainerType) {
                            // Valido que tenga permisos para el tc
                            containerTypeService.isContainertypeInRole(['EMPLOYEEFILE WRITE', 'EMPLOYEEFILE ADM'], customContainerType.id).then(function (r) {
                                if (!r) {
                                    errors.showError('EDRTC');
                                    $scope.cancel();
                                }
                            }, function (error) {
                                errors.showError(error);
                                $scope.cancel();
                            });

                            $scope.loadContainerMetadata(customContainerType);
                        } else {
                            containerTypeService.getBySystemName("_leg").then(function (result) {
                                $scope.loadContainerMetadata(result);
                            }, function (error) {
                                errors.showError(error);
                            });
                        }
                    });
                };

                $scope.loadContainerMetadata = function (type) {
                    $scope.container.containerTypeName = type.name;
                    $scope.container.metadatas = [];
                    $scope.container.containerTypeId = type.id;

                    type.metadata.forEach(function (metadata) {
                        var newMetadata = {
                            idObject: type.id + '' + metadata.metadataId,
                            metadataId: metadata.metadataId,
                            metadataIsRequired: metadata.isRequired,
                            metadataIsUnique: metadata.isUnique,
                            metadataValue: '',
                            metadataType: metadata.metadataType,
                            metadataLabel: metadata.metadataLabel,
                            metadataOptions: metadata.optionValues,
                            mask: metadata.metadataMask,
                            maskPlaceHolder: metadata.metadataMaskPlaceHolder,
                            maskOptions: metadata.metadataMaskOption,
                            metadataReplicate: metadata.isReplicated,
                            metadataSystemName: metadata.metadataSystemName,
                            metadataReadOnly: false,
                            metadataEnabled: true
                        };

                        $scope.container.metadatas.push(newMetadata);
                    });
                };

                $scope.metadataTypeCount = function () {
                    if ($scope.container.metadatas) {
                        return $scope.container.metadatas.length;
                    }

                    return 0;
                };

                $scope.save = function () {
                    if (!$scope.validDates()) {
                        errors.showError('InvalidDates');
                        return false;
                    }
                    if (!$scope.employeeFileForm.$valid) {
                        $scope.employeeFileForm.$setSubmitted();
                        errors.showError('VerifyContainerFormData');
                        return false;
                    }

                    $scope.container.organizationalUnitId = $scope.organizationalUnit.id;
                    $scope.container.organizationalUnitName = $scope.organizationalUnit.name;

                    return documentContainerService.createAndCheckin($scope.container).then(function () {
                        // Verifico si tiene decalración automatica de certificados
                        organizationalUnitConfigService.getValue($scope.organizationalUnit.id, 'OuConfigCertificateProviders', 'AutoDeclareCertificate').then(function (result) { 
                            if (result && result != "empty") {
                                //obtengo los providers
                                certificateService.getProviders(0).then(function (providers) {

                                    // Obtego el provider del automatico
                                    var provider = providers.filter(function (config) {
                                        return config.name.toLocaleUpperCase() === result.toLocaleUpperCase();
                                    })[0];


                                    var leg = $scope.container.metadatas.filter(function (meta) {
                                        return meta.metadataSystemName === '_nroleg';
                                    })[0];
                                    var cuil = $scope.container.metadatas.filter(function (meta) {
                                        return meta.metadataSystemName === '_cuil';
                                    })[0];
                                    var userId = $scope.container.metadatas.filter(function (meta) {
                                        return meta.metadataSystemName === '_userId';
                                    })[0];

                                    // Armo entidad Certificate
                                    var certificate = {
                                        IdLegajo: leg.metadataValue,
                                        Cuil: cuil.metadataValue,
                                        OrganizationalUnitId: provider.requiredOU ? $scope.organizationalUnit.id : null,
                                        UserId: userId.metadataValue,
                                        Type: 0,
                                        ProviderId: provider.id
                                    };

                                    // Llamo al crear certificado
                                    profileCertificateService.upload(certificate, null).then(function () {
                                        $state.go('employee-file-find');
                                    }, function (error) {
                                        errors.showError(error);
                                    });
                                }, function (error) {
                                    // errors.showError(error);
                                    $state.go('employee-file-find');
                                });
                            } else {
                                $state.go('employee-file-find');
                            }
                        }, function (error) {
                           // errors.showError(error);
                            $state.go('employee-file-find');
                        });
                    }, function (error) {
                        if (error.data !== null || error.data !== "", error.data.modelState !== null || error.data.modelState !== "")
                            error.data.modelState.error[0] = $filter('translate')(error.data.modelState.error[0])
                        errors.showError(error);
                    });
                };

                $scope.changeEmployeeOu = function () {
                    $filter('filter')($scope.container.metadatas, { metadataType: 'userControl' }, true).forEach(function (m) {
                        m.metadataValue = undefined;
                    });
                };

                $scope.load();

                $scope.validDates = function () {
                    return true;
                };

            }]);
})();